
<template>
  <div class="my-wrap">
    <ul class="nav-tabs my-mall-exchange-tabs">
      <!-- <li :class="{ 'active': $route.path === '/points/membership-benefits' || $route.path === '/points/free-spin' }" @click="$router.push('/points/membership-benefits')">
        <a>
          {{ $t('Bao.point_type') }}
        </a>
      </li> -->
      <li v-if="user.lotteryId" :class="{ 'active': $route.path === '/points/roulette-bonus' }" @click="$router.push('/points/roulette-bonus')">
        <!-- <li :class="{ 'active': $route.path === '/points/roulette-bonus' || $route.path === '/points/rebate' }" @click="$router.push('/points/roulette-bonus')"> -->
        <a>
          {{ $t('Bao.bet_exchange') }}
        </a>
      </li>
      <li :class="{ 'active': $route.path === '/points/vip-rewards' }" @click="$router.push('/points/vip-rewards')">
        <a>
          {{ $t('Bao.vip_type') }}
        </a>
      </li>
      <li :class="{ 'active': $route.path === '/points/coupon' }" @click="$router.push('/points/coupon')">
        <a>
          {{ $t('Bao.coupon') }}
        </a>
      </li>
    </ul>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
